import { useDeleteDefaultRecordValueConfiguration } from "#src/components/hooks/adapters/useDefaultRecordValueConfig";
import { Button, Dialog } from "@validereinc/common-components";
import { DefaultRecordValueConfigurationType } from "@validereinc/domain";
import React from "react";

export const DeleteDefaultRecordValueConfigurationDialog = ({
  isOpen,
  onClose,
  itemToDelete,
}: {
  isOpen: boolean;
  onClose: () => void;
  itemToDelete: DefaultRecordValueConfigurationType["id"];
}) => {
  const onSuccess = () => {
    onClose?.();
  };

  const deleteDefaultRecordValueConfiguration =
    useDeleteDefaultRecordValueConfiguration({ onSuccess });

  const handleSubmit = () => {
    deleteDefaultRecordValueConfiguration.mutate({
      id: itemToDelete,
    });
  };

  return (
    <Dialog
      title="Delete Record Automation Configuration"
      isOpen={isOpen}
      onClose={onClose}
      actionRow={[
        <Button
          key="delete-default-record-value-config"
          variant="error"
          onClick={handleSubmit}
        >
          Delete
        </Button>,
      ]}
    >
      Are you sure you want to delete this record automation configuration? This
      action can not be undone.
    </Dialog>
  );
};
